
// This returns a Promise
function getGeocodeFromX(X: google.maps.GeocoderRequest): Promise<google.maps.GeocoderResult> {
    return new Promise<google.maps.GeocoderResult>((resolve, reject) => {
        const geoCoder = new google.maps.Geocoder();
        geoCoder.geocode(X, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK) {
                let addressIn: google.maps.GeocoderResult | null = null;
                if (results.length > 0) {
                    for (let i = 0; i < results.length; i++) {
                        if (results[i].types.indexOf("premise") >= 0) {
                            addressIn = results[i];
                        }
                        if (!addressIn) {
                            if (results[i].types.indexOf("street_address") >= 0) {
                                addressIn = results[i];
                            }
                        }
                    }
                    if (!addressIn) {
                        addressIn = results[0];
                    }
                }

                if (addressIn !== null) {
                    resolve(addressIn);
                } else {
                    reject('No location available here, please check details and search again');
                }
            } else {
                reject('Address was not located on map for the following reason: ' + status);
            }
        });
    });
}

export function getGeocodeFromAddress(addressText: string): Promise<google.maps.GeocoderResult> {
    return getGeocodeFromX({
        'address': addressText
    });
}

export function getGeocodeFromLocation(location: google.maps.LatLng): Promise<google.maps.GeocoderResult> {
    return getGeocodeFromX({
        'location': location
    });
}

